'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { QuatroPoppup } from '@eliadmin/core/src/components/cart/detail/quatro/quatro-poppup';
import { Dialog, DialogTrigger } from '@eliadmin/core/src/components/ui/dialog';

import { FaCalculator } from 'react-icons/fa';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export function ProductQuatro({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const isWholesaler = useCustomerStore(state => state.me?.customer.is_wholesaler);
  const priceDisplay = getProductPriceDisplay(selectedVariant ?? product, { isWholesaler });

  if (priceDisplay.currentWithVat == null) return null;

  return (
    <div className="flex w-full items-center justify-between">
      <Dialog>
        <DialogTrigger className="flex items-center justify-start gap-2 text-sm font-medium text-primary">
          <FaCalculator size={20} className="text-primary" />{' '}
          <p className="underline">Vypočítať splátky</p>
        </DialogTrigger>
        <QuatroPoppup price={priceDisplay.currentWithVat} />
      </Dialog>
      <Image
        src={'/images/quatro.png'}
        alt="Quatro"
        width={0}
        height={0}
        className="max-h-[27px] min-h-[27px] w-auto object-contain object-center"
        sizes="300px"
      />
    </div>
  );
}
